var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGolden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.333 26.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.166 0a9.052 9.052 0 109.056 9.052A9.062 9.062 0 0013.166 0zm4.756 7.772L16.361 9.73l.171 2.559a.819.819 0 01-.346.726.829.829 0 01-.477.151.806.806 0 01-.321-.066l-2.222-.943-2.22.943a.823.823 0 01-1.144-.811l.171-2.559L8.41 7.772a.823.823 0 01.434-1.31l2.334-.611 1.28-2.156a.853.853 0 011.414 0l1.28 2.156 2.335.611a.824.824 0 01.436 1.31z",
    fill: "#feda6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.908 14.39l-3.8 6.595a.823.823 0 00.927 1.206l4.832-1.3 1.285 4.832a.825.825 0 00.686.6h.109a.823.823 0 00.713-.411l3.593-6.218a10.7 10.7 0 01-8.345-5.304z",
    fill: "#feda6f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.224 20.985l-3.8-6.595a10.7 10.7 0 01-8.346 5.314l3.593 6.218a.823.823 0 00.713.411.782.782 0 00.107-.007.827.827 0 00.688-.6l1.285-4.832 4.832 1.3a.824.824 0 00.928-1.2z",
    fill: "#feda6f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolden);
export default __webpack_public_path__ + "static/media/golden.e49a21c9526c6f2ec04ce933d0a6a1e3.svg";
export { ForwardRef as ReactComponent };